<app-tooltip selectorForTrigger=".infoIcon" [placement]="placement">
  <i class="infoIcon material-icons" style="vertical-align: middle;" trigger>info_outline</i>
  <div content>
    <div style="width: 88vw;max-width: 350px; margin: 5px; text-align: left;">
      Net IRR (2% Finzy fees + 18% GST on the fees) may differ from ROI of the loan due to:
      <ul style="padding-left: 5%;">
        <li>Monthly periodicity of payouts from finzy loans</li>
        <li>Original tenure of the loan</li>
      </ul>
    </div>
  </div>
</app-tooltip>
